export enum MessageStatusType {
  NotSet = "NotSet",
  Info = "Info",
  Warning = "Warning",
  Error = "Error"
}
